module.exports = __webpack_public_path__ + "img/ga-Funded by the EU_NEG.57d62ca.svg";